export function detectDevice(): {
  os: string
  browser: string
  deviceType: string
} {
  const ua = navigator.userAgent

  // 操作系统检测
  const osMap = {
    iOS: /iPhone|iPad|iPod/.test(ua),
    Android: /android/i.test(ua),
    Windows: /windows nt/i.test(ua),
    Mac: /macintosh|mac os x/i.test(ua),
    Linux: /linux/i.test(ua)
  }

  // 浏览器检测
  const browserMap = {
    Chrome: /chrome/i.test(ua),
    Firefox: /firefox/i.test(ua),
    Safari: /safari/i.test(ua),
    Edge: /edg/i.test(ua),
    Opera: /opera|opr/i.test(ua)
  }

  // 设备类型
  const deviceMap = {
    Tablet: /ipad|android tablet/i.test(ua),
    Phone: /iphone|android.*mobile/i.test(ua),
    Desktop: !/mobi|android|iphone/i.test(ua)
  }

  return {
    os: Object.entries(osMap).find(([_, v]) => v)?.[0] || 'Unknown',
    browser: Object.entries(browserMap).find(([_, v]) => v)?.[0] || 'Unknown',
    deviceType: Object.entries(deviceMap).find(([_, v]) => v)?.[0] || 'Unknown'
  }
}
